import React from 'react';

import { Toggle } from '../../components';
import { USER_INFORMED_ABOUT_COOKIES_USAGE } from '../../utils/variables';
import styles from './styles.scss';

const setCookie = () => localStorage.setItem(USER_INFORMED_ABOUT_COOKIES_USAGE, true);
const showPopup = !localStorage.getItem(USER_INFORMED_ABOUT_COOKIES_USAGE);

const CookiesUsagePopup = () => (
  <Toggle toggle={setCookie}>
    {({ on, toggle }) =>
      showPopup &&
      !on && (
        <div className={styles.popup}>
          <p>
            We use cookies to make your website experience better. <br /> To learn about how we keep your information
            safe, view our <a href={'/forms-and-policies'}>Privacy Policy</a>.
          </p>
          <div onClick={toggle} className={'btn'}>
            <span>Ok</span>
          </div>
        </div>
      )
    }
  </Toggle>
);

export default CookiesUsagePopup;



// WEBPACK FOOTER //
// ./src/containers/Content/CookiesUsagePopup.js